import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import useOrgUnitAdminReportingMyMeets from './UseOrgUnitAdminReportingMyMeets';

import ReportList from '@usas/ui-web/components/embeddedReports/ReportList';

const OrgUnitAdminReportingMyMeets = () => {
  const { reportParameters, contextId, routeName, state, onNextButtonClicked, onSaveAndExitButtonClicked,
    onBackButtonClicked } = useOrgUnitAdminReportingMyMeets();

  return (
    <ViewTemplate
      viewName={Views.OME_MEET_ENTRY_REPORTS}
      onNextButtonClicked={onNextButtonClicked}
      onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
      onBackButtonClicked={onBackButtonClicked}
      errorMessage={state.error}>
      <ReportList listTitle=""
        routeName={routeName}
        contextId={contextId}
        reportParameters={reportParameters} />
    </ViewTemplate>
  );
};

export default OrgUnitAdminReportingMyMeets;